import {useSelector} from 'react-redux';
import Selector from '../../../../../../selectors/pages/home/facebook_boost';
import ModalsLib from '../../../../../../lib/modals';
import {navigate} from '../../../../../../utils/navigation';
import WhiteButton from '../../../../../components/white-button';

export default () => {
    const {isAuth} = useSelector(Selector);

    return (
        <div className="slide bonus-zone size-params">
            <div className="size-params-layer layer0"><div className="girl"></div></div>
            <div className="layer-margin size-params-layer layer1"><div className="case1"></div></div>
            <div className="layer-margin size-params-layer layer2">
                <div className="light">
                    <div className="circle"></div>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="layer-margin size-params-layer layer3"><div className="diamond"></div></div>
            <div className="layer-margin size-params-layer layer4"><div className="diamond"></div></div>
            <div className="layer-margin size-params-layer layer5">
                <div className="light">
                    <div className="circle"></div>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="layer-margin size-params-layer layer6">
                <div className="light">
                    <div className="circle"></div>
                    <div className="dot"></div>
                </div>
            </div>
            <div className="layer-margin size-params slide-details">
                <div className="title">
                    BONUS<br/>ZONE
                </div>
                <div className="descriptions-short">Earn Diamonds, play games, and unlock real cash rewards!!</div>
                <div className="details">
                    <WhiteButton onClick={e => {
                        if(isAuth)
                            navigate('/tasks')
                        else
                            ModalsLib.open('signin')
                    }}>View more</WhiteButton>
                </div>
            </div>
        </div> 
    )
} 